import HttpRequest from "@/util/HttpRequest";

export default {
  /**
   * 회사 목록
   * @params {page, perPage}
   */
  async LOAD_COMPANY_LIST({ commit }, params) {
    if (!params.projectId) return;

    const option = { params };

    return new Promise((resolve, reject) => {
      HttpRequest.get("/api/v1/company", option)
        .then((response) => {
          // mutations 메소드 호출
          commit("LOAD_COMPANY_LIST", response);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  /**
   * 회사 목록
   * @params {page, perPage}
   */
  async LOAD_COMPANY_TREE({ commit }, params) {
    if (!params.projectId) return;

    const option = {
      params: {
        projectId: params.projectId,
      },
    };

    if (params.all) {
      option.params.all = params.all;
    }

    const cacheKey = `sub_company_${params.projectId}`;
    const cachedData = localStorage.getItem(cacheKey);

    if (cachedData) {
      try {
        const parsedData = JSON.parse(cachedData);
        const cachedTime = parsedData.timestamp || 0;
        const currentTime = new Date().getTime();

        // 캐시가 1시간(3600000 밀리초) 이내인 경우에만 사용
        if (currentTime - cachedTime < 3600000) {
          commit("LOAD_COMPANY_TREE", parsedData.data);
          return parsedData.data;
        }
      } catch (e) {
        // 캐시 파싱 오류 시 무시
      }
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get("/api/v1/company/tree", option)
        .then((response) => {
          // 데이터와 타임스탬프를 함께 저장
          const dataToCache = {
            data: response,
            timestamp: new Date().getTime(),
          };
          localStorage.setItem(cacheKey, JSON.stringify(dataToCache));

          // mutations 메소드 호출
          commit("LOAD_COMPANY_TREE", response);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  async LOAD_COMPANY({ commit, state }, params) {
    const companyId = params.companyId;
    if (!companyId) {
      console.error("company/LOAD_COMPANY : companyId 가 없습니다.");
      return;
    }

    if (!state.companyInfo || `${state.companyInfo.id}` !== `${companyId}`) {
      return new Promise((resolve, reject) => {
        HttpRequest.get(`/api/v1/company/${companyId}`)
          .then((response) => {
            // mutations 메소드 호출
            commit("LOAD_COMPANY", response);
            resolve(response);
          })
          .catch((err) => reject(err));
      });
    }
  },

  async LOAD_COMPANY_FIELD({ commit }, params) {
    const companyId = params.companyId;

    const option = {
      params: {
        page: params.page,
        perPage: params.perPage,
        fieldName: params.fieldName,
        fieldCode: params.fieldCode,
        projectId: params.projectId,
        fieldType: params.fieldType,
      },
    };

    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/company/field/${companyId}`, option)
        .then((response) => {
          // mutations 메소드 호출
          commit("LOAD_COMPANY_FIELD", response);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  async LOAD_MEMBER_LIST({ commit }, params) {
    const option = {
      params: {
        page: params.page,
        perPage: params.perPage,
        company_id: params.company_id,
      },
    };

    return new Promise((resolve, reject) => {
      HttpRequest.get("/api/v1/company/member", option)
        .then((response) => {
          // mutations 메소드 호출
          commit("LOAD_MEMBER_LIST", response);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },
};
